import React from "react";
import { Box } from "@mui/material";

import { useGetDashboardQuery } from "api/dashboard";
import { BalanceSummaryTable } from "./BalanceSummaryTable";
import { CardContainer } from "./CardContainer";
import { DashboardLoadingSkeleton } from "./DashbaordLoadingSkeleton";
import { DataChart } from "./DashboardChart/DataChart";

export function DashboardContent() {
  const { data, isLoading, isError } = useGetDashboardQuery();

  if (isLoading || isError) {
    return <DashboardLoadingSkeleton />;
  }

  return (
    <>
      <CardContainer metrics={data} />
      <Box
        display="flex"
        flexDirection="column"
        gap={4}
        sx={{ paddingTop: "40px" }}
      >
        <DataChart />
        <BalanceSummaryTable balances={data?.balances || []} />
      </Box>
    </>
  );
}
